import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowReferenceService {

  constructor() { }

  get nativeWindow(): Window {
    return this.getWindow();
  }

  private getWindow(): Window {
    return window;
  }
}
